import React, { useEffect, useState } from "react";
import readerImg from "../../assets/images/reader-placeholder.png";
import fundImg from "../../assets/images/fund-placeholder.png";
import shopImg from "../../assets/images/shop-placeholder.png";

const APPS = [
  { label: "Ap Digital Library", image: readerImg, alt: "Comics reader", destination: "/reader" },
  { label: "Fund Go Crowdfunding", image: fundImg, alt: "Crowdfunding campaigns", destination: "/fund" },
  { label: "Ap Shop", image: shopImg, alt: "Merchandise shop", destination: "/shop" },
];

const MOBILE_BREAKPOINT = 768;

export default function ThreeAppLinks() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false
  );
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ ...rowStyle, ...(isMobile ? rowStyleMobile : {}) }}>
      {APPS.map((app, index) => {
        const isHovered = hoveredIndex === index;
        return (
          <div
            key={app.destination}
            role="button"
            tabIndex={0}
            aria-label={`Open ${app.label}`}
            style={{
              ...cardStyle,
              transform: isHovered ? "scale(1.03)" : "scale(1)",
              borderColor: isHovered ? "#ffffff" : "rgba(255,255,255,0.85)",
              boxShadow: isHovered
                ? "0 12px 28px rgba(0,0,0,0.32)"
                : "0 6px 16px rgba(0,0,0,0.18)",
            }}
            onClick={() => window.location.assign(app.destination)}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                window.location.assign(app.destination);
              }
            }}
          >
            <img src={app.image} alt={app.alt} style={cardImageStyle} />
            <div style={captionStyle}>
              <span style={captionTextStyle}>{app.label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

const rowStyle = {
  display: "flex",
  gap: "1rem",
  marginBottom: "2rem",
};

const rowStyleMobile = {
  flexDirection: "column",
};

const cardStyle = {
  flex: 1,
  position: "relative",
  borderRadius: "12px",
  overflow: "hidden",
  cursor: "pointer",
  transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
  // White outline: these sit directly on the cycling parallax background
  // (ParallaxBackground.js), where the previous rgba(255,255,255,0.08) hairline
  // was invisible against the art. borderColor is overridden per-card on hover.
  border: "2px solid rgba(255,255,255,0.85)",
  background: "#1a1a1a",
};

const cardImageStyle = {
  width: "100%",
  height: "220px",
  objectFit: "cover",
  display: "block",
};

const captionStyle = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  background: "rgba(0,0,0,0.62)",
  padding: "0.6rem 1rem",
};

const captionTextStyle = {
  color: "#ffffff",
  fontWeight: 700,
  fontSize: "1rem",
  letterSpacing: "0.02em",
};
